import { useContext } from "react"
import UserContext from "../userContext/userContext"
import { Redirect } from 'react-router-dom'


export default function Topbar() {

    let userData = useContext(UserContext);
 
    

    return <>
        <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">


            <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                <i className="fa fa-bars"></i>
            </button>


            <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
                <div className="input-group">
                    <input type="text" className="form-control bg-light border-0 small" placeholder="Search for..."
                        aria-label="Search" aria-describedby="basic-addon2" />
                    <div className="input-group-append">
                        <button className="btn btn-secondary" type="button">
                            <i className="fas fa-search fa-sm"></i>
                        </button>
                    </div>
                </div>
            </form>

            

           <p>{userData.userlist.firstname} {userData.userlist.lastname}</p>
           <button type="button" className="btn btn-secondary" onClick={()=>{
            userData.setuserLoggedIn(false)
            if(!userData.userLoggedIn){
                return <Redirect to="/"/>
            }
           }}>Logout</button>
           
        </nav>
    </>
}